import { render, staticRenderFns } from "./ShiftCustomSouffling.vue?vue&type=template&id=25b2b0a3&"
import script from "./ShiftCustomSouffling.vue?vue&type=script&lang=ts&"
export * from "./ShiftCustomSouffling.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftCustomSouffling.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports